import styled from 'styled-components';
import { StylesConfig, GroupBase, Props } from 'react-select';
import { alto, mirage, blueMana } from '@paradigm/design-system/src/colors';
import ArrowDown from '@paradigm/design-system/src/assets/ArrowDown';
import { Tab } from '@paradigm/features/src/unified-rfqs/ui/bottom-tabs';
import Select, {
  addStyles,
} from '@paradigm/design-system/src/components/Select';
import { OptionTypeBase } from '@paradigm/design-system/src/components/Select/types';

export interface PageOption extends OptionTypeBase {
  value: Tab;
  label: string;
}

export default function MobilePageSelect(
  props: Props<PageOption, false, GroupBase<PageOption>>,
) {
  return (
    <Container>
      <Select
        {...props}
        components={{
          IndicatorSeparator: () => null,
          DropdownIndicator: () => <ArrowDown width={14} fill={alto} />,
        }}
        styles={stylesSelect}
        isSearchable={false}
      />
    </Container>
  );
}

const stylesSelect: StylesConfig<PageOption, false, GroupBase<PageOption>> = {
  menu: addStyles(() => ({
    backgroundColor: mirage,
    zIndex: 3,
    fontSize: '1rem',
  })),
  dropdownIndicator: addStyles(() => ({
    color: 'white',
  })),
  indicatorsContainer: addStyles(() => ({
    transform: 'translateX(-10px)',
  })),
  placeholder: addStyles(() => ({ color: 'white', fontSize: '1rem' })),
  input: addStyles(() => ({ color: 'white' })),
  singleValue: addStyles(() => ({
    color: 'white',
    fontSize: '1.25rem',
  })),
  option: (styles, { isSelected }) => ({
    ...styles,
    backgroundColor: isSelected ? blueMana : mirage,
  }),
  control: addStyles(() => ({
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    boxShadow: 'none',
  })),
};

const Container = styled.div`
  text-transform: capitalize;
  width: 180px;
`;
